export default "__VITE_ASSET__24qbKNPc__"